import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
  Image,
} from "@react-pdf/renderer";
import dayjs from "dayjs";

Font.register({
  family: "Manrope",
  fonts: [
    { src: "/fonts/Manrope-Regular.ttf" },
    { src: "/fonts/Manrope-Bold.ttf", fontWeight: "bold" },
  ],
});

const styles = StyleSheet.create({
  page: {
    paddingTop: 5,
    paddingBottom: 70,
    fontSize: 10,
    fontFamily: "Manrope",
    color: "#333",
  },
  headerSpace: {
    width: "100%",
    height: 80, // Slightly reduced to avoid taking too much space
    marginBottom: 20,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  header_image: {
    width: "100%", // Not fully filled to look cleaner
    height: "100%",
    // objectFit: "contain",
  },
  contentWrapper: {
    paddingHorizontal: 30,
  },
  mainTitle: {
    fontSize: 16,
    fontWeight: "bold",
    textAlign: "center",
    textTransform: "uppercase",
    marginBottom: 15,
    // borderBottomWidth: 1.5,
    // borderBottomColor: "#000",
    paddingBottom: 3,
  },
  infoSection: {
    flexDirection: "row",
    borderWidth: 1,
    borderColor: "#000",
  },
  infoBox: {
    flex: 1,
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 6,
  },
  // Fixed width for the right-side boxes to ensure perfect alignment
  rightBox: {
    width: 120,
    padding: 6,
  },
  label: {
    fontSize: 7,
    color: "#666",
    textTransform: "uppercase",
    marginBottom: 2,
    fontWeight: "bold",
  },
  value: {
    fontSize: 9,
    fontWeight: "bold",
  },
  fullWidthBox: {
    width: "100%",
    borderWidth: 1,
    borderTopWidth: 0,
    borderColor: "#000",
    padding: 6,
    marginBottom: 15,
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#f2f2f2",
    borderWidth: 1, // Added full border
    borderColor: "#000",
    // borderTopWidth is now included in the '1' above
  },
  tableRow: {
    flexDirection: "row",
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#000",
    minHeight: 22,
    alignItems: "center",
  },
  cell: {
    width: "6%", // adjust as needed
    padding: 3,
    fontSize: 7,
  },
  cellRight: {
    flex: 0.8,
    padding: 4,
    fontSize: 8,
    textAlign: "right",
    fontWeight: "bold",
  },
  signatureSection: {
    position: "absolute",
    bottom: 40,
    left: 30,
    right: 30,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  signBox: {
    width: "20%",
    borderTopWidth: 1,
    borderTopColor: "#000",
    paddingTop: 5,
    textAlign: "center",
    fontSize: 8,
    fontWeight: "bold",
  },
  footerPageInfo: {
    position: "absolute",
    bottom: 15,
    left: 30,
    right: 30,
    flexDirection: "row",
    justifyContent: "space-between",
    fontSize: 7,
    color: "grey",
  },
  rowBetween: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },

  durationBox: {
    flexDirection: "row",
    justifyContent: "space-around",
    backgroundColor: "#f2f2f2",
    padding: 10,
    marginVertical: 10,
  },

  durationItem: {
    alignItems: "center",
  },

  bold: {
    fontWeight: "bold",
    fontSize: 12,
  },

  sectionTitle: {
    fontWeight: "bold",
    fontSize: 12,
  },

  red: {
    color: "red",
    fontWeight: "bold",
  },

  totalBox: {
    marginTop: 15,
    backgroundColor: "#d4edda",
    padding: 10,
    flexDirection: "row",
    justifyContent: "space-between",
    borderRadius: 5,
  },

  totalText: {
    fontSize: 12,
    fontWeight: "bold",
  },

  totalAmount: {
    fontSize: 14,
    fontWeight: "bold",
    color: "red",
  },
  headerSpace: {
    width: "100%",
    height: 80, // Slightly reduced to avoid taking too much space
    marginBottom: 20,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  header_image: {
    width: "95%", // Not fully filled to look cleaner
    height: "100%",
    objectFit: "contain",
  },
  contentWrapper: {
    paddingHorizontal: 30,
  },
  footer: {
    position: "absolute",
    bottom: 15,
    left: 30,
    right: 30,
    textAlign: "center",
    fontSize: 8,
    color: "grey",
  },

  card: {
    borderWidth: 1,
    borderColor: "#ccc",
    borderRadius: 6,
    padding: 10,
    marginBottom: 10,
  },

  cardHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 6,
    borderBottomWidth: 1,
    borderColor: "#eee",
    paddingBottom: 4,
  },

  cardTitle: {
    fontSize: 11,
    fontWeight: "bold",
  },

  status: {
    fontSize: 9,
    fontWeight: "bold",
    color: "green",
  },

  row: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 3,
  },
  rowSub: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "8",
    alignItems: "center",
    marginBottom: 3,
  },

  label: {
    fontSize: 8,
    color: "#666",
    marginRight: 3,
  },

  value: {
    fontSize: 9,
    fontWeight: "bold",
    marginRight: 10,
  },
});

const FleetListDocument = ({ fleetListPrintData }) => {
  const bondTimeportNoData = JSON.parse(
    localStorage.getItem("BondTimeportNoData") || "[]",
  );
  console.log("bondTimeportNoData:", bondTimeportNoData);
  const headerImage = bondTimeportNoData[0]?.REP_HEADER;
  const footerImage = bondTimeportNoData[0]?.REP_FOOTER;

  console.log("fleetListPrintData:", fleetListPrintData);

  const formatCurrency = (amt) =>
    Number(amt || 0).toLocaleString(undefined, { minimumFractionDigits: 2 });

  const colWidths = [
    "5%",
    "8%",
    "7%",
    "6%",
    "6%",
    "6%",
    "8%",
    "8%",
    "8%",
    "7%",
    "8%",
    "10%",
    "8%",
    "8%",
    "8%",
    "10%",
    "7%",
  ];

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.headerSpace} fixed>
          {headerImage && (
            <Image src={headerImage} style={styles.header_image} />
          )}
        </View>
        <View style={styles.contentWrapper}>
          <Text style={styles.mainTitle}>Fleet List</Text>

          {fleetListPrintData?.map((d, index) => (
            <View key={index} style={styles.card} wrap={false}>
              {/* Header */}
              <View style={styles.cardHeader}>
                <Text style={styles.cardTitle}>
                  {d?.REG_NO || "Vehicle"} ({d?.TYPE})
                </Text>
                <Text style={styles.status}>{d?.STATUS}</Text>
              </View>

              {/* Row 1 */}
              <View style={styles.row}>
                <View style={styles.rowSub}>
                  <Text style={styles.label}>Make:</Text>
                  <Text style={styles.value}>{d?.MAKE}</Text>
                </View>

                <View style={styles.rowSub}>
                  <Text style={styles.label}>Model:</Text>
                  <Text style={styles.value}>{d?.MODEL}</Text>
                </View>

                <View style={styles.rowSub}>
                  <Text style={styles.label}>Odometer:</Text>
                  <Text style={styles.value}>{d?.ODOMENTER}</Text>
                </View>
              </View>

              {/* Row 2 */}
              <View style={styles.row}>
                <View style={styles.rowSub}>
                  <Text style={styles.label}>Reg On:</Text>
                  <Text style={styles.value}>
                    {d["REGISTRAION ON"]
                      ? dayjs(d["REGISTRAION ON"]).format("DD-MMM-YYYY ")
                      : "-"}
                  </Text>
                </View>

                <View style={styles.rowSub}>
                  <Text style={styles.label}>Reg Exp:</Text>
                  <Text style={styles.value}>
                    {d?.REG_EXPIRY
                      ? dayjs(d.REG_EXPIRY).format("DD-MMM-YYYY ")
                      : "-"}
                  </Text>
                </View>

                <View style={styles.rowSub}>
                  <Text style={styles.label}>Engine No:</Text>
                  <Text style={styles.value}>{d["ENGINE NO"]}</Text>
                </View>
              </View>

              {/* Row 4 */}
              <View style={styles.row}>
                <View style={styles.rowSub}>
                  <Text style={styles.label}>Purchase Amt:</Text>
                  <Text style={styles.value}>{d?.PURCHASE_AMOUNT}</Text>
                </View>

                <View style={styles.rowSub}>
                  <Text style={styles.label}>Premium:</Text>
                  <Text style={styles.value}>{d?.PREMIUM}</Text>
                </View>

                <View style={styles.rowSub}>
                  <Text style={styles.label}>Custodian:</Text>
                  <Text style={styles.value}>{d?.CURRENT_CUSTODIAN}</Text>
                </View>
              </View>

              {/* Row 6 */}
              <View style={styles.row}>
                  <Text style={styles.label}>Account No:</Text>
                  <Text style={styles.value}>{d?.ACCOUNTNO}</Text>

                  <Text style={styles.label}>Department:</Text>
                  <Text style={styles.value}>{d?.DEPARTMENT}</Text>

                  <Text style={styles.label}>Insurance Exp:</Text>
                  <Text style={styles.value}>
                    {d["INSURANCE EXPIRY"]
                      ? dayjs(d["INSURANCE EXPIRY"]).format("DD-MMM-YYYY ")
                      : "-"}
                  </Text>

                  <Text style={styles.label}>Company:</Text>
                  <Text style={styles.value}>{d?.INS_COMPANY}</Text>
              </View>
            </View>
          ))}
        </View>
        <View style={styles.footer} fixed>
          {footerImage && (
            <Image src={footerImage} style={styles.header_image} />
          )}
        </View>
      </Page>
    </Document>
  );
};

export default FleetListDocument;
